import { ReactElement } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import LogInPage from './views';

const LoginRoute = (): ReactElement => (
  <LogInPage />
);

export default LoginRoute;
